export const stripDuplicates = (array) => Array.from(new Set(array));
